var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKidsbabyunit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_2",
    "data-name": "katman 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.68 19.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "katman_1",
    "data-name": "katman 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#a7a8a9",
    strokeWidth: 0,
    d: "M21.06,19.08H1.61c-.59,0-1.12-.31-1.41-.82-.28-.5-.27-1.1.03-1.59L9.96.77c.29-.48.81-.77,1.38-.77s1.09.29,1.38.77l9.72,15.9c.3.49.31,1.09.03,1.59-.29.51-.82.82-1.41.82M11.34.8c-.29,0-.55.14-.7.39L.92,17.09c-.15.25-.16.53-.02.78.14.26.41.41.71.41h19.45c.3,0,.57-.15.71-.41.14-.25.13-.53-.02-.78L12.03,1.19c-.15-.24-.41-.38-.7-.38"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a7a8a9",
    strokeWidth: 0,
    d: "M19.09,17.17H3.59c-.35,0-.68-.19-.84-.49-.16-.3-.16-.65.02-.94L10.52,3.27c.35-.57,1.29-.57,1.64,0l7.75,12.47c.18.29.19.64.02.94-.17.3-.49.49-.84.49M11.34,3.62s-.1,0-.14.07l-7.75,12.47s-.03.08,0,.12c.01.02.05.08.14.08h15.49c.09,0,.13-.06.14-.08.02-.04.02-.08,0-.12L11.48,3.69c-.04-.07-.11-.07-.14-.07"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKidsbabyunit);
export default __webpack_public_path__ + "static/media/KIDSBABYUNIT.65592d76de59786d41f967bfd0ea0dac.svg";
export { ForwardRef as ReactComponent };